export default {
  labels: {
    doctor: 'Doctor',
    room: 'Room',
  },
  placeholders: {
    searchDoctor: 'Search doctor',
  },
};
